import { Component, OnInit } from '@angular/core';
import { AgilityRiskService } from '../../../../providers/agility-risk.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ThreatType } from '../../../../models/threat-type';
import { TranslateService } from '@ngx-translate/core';
import { AgilityRiskMessageService } from '../../../../providers/agility-risk-message.service';

@Component({
  selector: 'lib-add-edit-threat',
  templateUrl: './add-edit-threat.component.html',
  styleUrls: ['./add-edit-threat.component.scss']
})
export class AddEditThreatComponent implements OnInit {
  threatForm: FormGroup;
  public threatData: any;
  public riskTemplateId: string;
  threatTypes: Array<ThreatType>;

  constructor(private riskService: AgilityRiskService,
              private dynamicDialogConfig: DynamicDialogConfig,
              private dynamicDialogRef: DynamicDialogRef,
              private messageService: AgilityRiskMessageService,
              private translateService: TranslateService,) {
    this.riskService.getThreatTypes().subscribe(threatTypes => this.threatTypes = threatTypes);
    if (this.dynamicDialogConfig.data) {
      this.threatData = this.dynamicDialogConfig.data.threatData;
      this.riskTemplateId = this.dynamicDialogConfig.data.riskTemplateId;
    }
  }

  ngOnInit(): void {
    this.initializeForm();
  }

  initializeForm() {
    if (!this.threatData?.id) {
      this.threatForm = new FormGroup({
        threatTypeId: new FormControl(null, Validators.required),
        name: new FormControl(null, Validators.required),
        description: new FormControl(null),
        isPlanRequired: new FormControl(false),
      });
    } else {
      this.threatForm = new FormGroup({
        id: new FormControl(this.threatData.id),
        threatTypeId: new FormControl(this.threatData.threatType?.id, Validators.required),
        name: new FormControl(this.threatData.name, Validators.required),
        description: new FormControl(this.threatData.description),
        isPlanRequired: new FormControl(this.threatData.requiresPlan),
      });
    }
  }

  saveThreat() {
    if (!this.threatData?.id) {
      this.riskService.createThreat(this.riskTemplateId, this.mapThreat(this.threatForm.value)).subscribe({
        next: (response) => {
          this.messageService.success(this.translateService.instant('common.success'), this.translateService.instant('riskTemplates.threat.saveThreat'));
          this.close(true);
        },
        error: (err) => {
          this.messageService.error(this.translateService.instant('common.error'), this.translateService.instant('riskTemplates.threat.saveThreatUnSuccessfully'));
        }
      });

      this.close(true);
    } else {
      this.riskService.updateThreat(this.mapThreat(this.threatForm.value)).subscribe({
        next: (response) => {
          this.messageService.success(this.translateService.instant('common.success'), this.translateService.instant('riskTemplates.threat.saveThreat'));
          this.close(true);
        },
        error: (err) => {
          this.messageService.error(this.translateService.instant('common.error'), this.translateService.instant('riskTemplates.threat.saveThreatUnSuccessfully'));
        }
      });
      this.close(true);
    }

  }

  mapThreat({id, threatTypeId, name, description, isPlanRequired}) {
    return {id, threatType: {id: threatTypeId}, name, description, requiresPlan: isPlanRequired};
  }

  close(isSaving?: boolean): void {
    return this.dynamicDialogRef.close(isSaving);
  }
}
